import { render, staticRenderFns } from "./PlannedLevelCompanion.vue?vue&type=template&id=6ec3c1f4&scoped=true&"
import script from "./PlannedLevelCompanion.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelCompanion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3c1f4",
  null
  
)

export default component.exports